module.exports = __webpack_public_path__ + "img/asset2.cb6bb6de.png";